// libs
import React, {useEffect, useState} from 'react'
import Pagination from "react-js-pagination";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
// components
import Navigation from "../../components/navbar";
import FormModal from './form-modal';
import UploadModal from './upload-modal';
import "../../assets/css/style.css";
import BreadcrumbNav from "../../components/breadcrumb-nav";
import Loading from '../../components/loading';
import Table from './table';
import Record404 from '../../components/record404';
import PrintErrorMsg from '../../components/print-error-msg';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from '../../config';
import utils from '../../utils';
import { useSelectedAccount } from '../../context/account-context';
import { navigateListPageUrl } from '../../utils/list-page-url';

function List({token, orgInfo}) {
	let query = utils.useQuery();
	const { selectedAccountId, selectedAccountDomain, hasSelectedAccount } = useSelectedAccount();
	const [ShowFormModalBox, setShowFormModalBox] = useState(false);
	const [ShowUploadModalBox, setShowUploadModalBox] = useState(false);
	const [ListData, setListData] = useState([]);
	const [TotalListCount, setTotalListCount] = useState(0);
	const [IsLoading, setIsLoading] = useState(true);
	const [IsError, setIsError] = useState(true);
	const [Is404, setIs404] = useState(false);
	const [SearchQInputVal, setSearchQInputVal] = useState(null);
	const [SelectedIds, setSelectedIds] = useState([]);
	const [IsDownloadingSelected, setIsDownloadingSelected] = useState(false);

	let paginationNo = query.get("page");
	let urlSearchQ = query.get("searchQ");
	let activePage = (utils.isNumeric(paginationNo)) ? parseInt(paginationNo) : 1;
	let offset = (activePage*config.pagination.limitPerPage)-config.pagination.limitPerPage;

	const handleChangeSearchQuery = (event) => {
		setSearchQInputVal(event.target.value);
	}

	const handlePageChange = (pageNumber) => {
		navigateListPageUrl(selectedAccountId, { set: { page: pageNumber } });
	}

	const submitSearchQuery = () => {
		navigateListPageUrl(selectedAccountId, {
			set: { searchQ: SearchQInputVal },
			remove: ['page'],
		});
	}

	const toggleSelect = (pkId) => {
		setSelectedIds(prev => prev.includes(pkId) ? prev.filter(id => id !== pkId) : [...prev, pkId]);
	}

	const toggleSelectAll = () => {
		setSelectedIds(prev => (prev.length === ListData.length) ? [] : ListData.map(d => d.pk_id));
	}

	const handleDownloadSelected = async () => {
		if (!SelectedIds.length) {
			return;
		}
		setIsDownloadingSelected(true);
		try {
			const response = await ajaxCall.downloadCall(`${config.api.generic}/inventory/export?accountId=${selectedAccountId}&ids=${SelectedIds.join(',')}`, token);
			const blob = new Blob([response.data], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			});
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');
			link.href = url;
			link.download = 'inventory_export_selected.xlsx';
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (err) {
			toast.error('Failed to download selected inventory');
		} finally {
			setIsDownloadingSelected(false);
		}
	}

	const loadApiData = async (loadOffset) => {
		setIsLoading(true);
		if(hasSelectedAccount) {
			let apiCall = await ajaxCall.getCall(`${config.api.generic}/inventory`, {
				offset: loadOffset,
				limit: config.pagination.limitPerPage,
				fAccount: selectedAccountId,
				fSearchQ: urlSearchQ
			}, token, {"Domain": "vyayata"});
			if(apiCall && apiCall.status) {
				setListData(apiCall.context.message.data.records);
				setTotalListCount(apiCall.context.message.data.totalCount);
				setIsLoading(false);
				setIsError(null);
				setIs404(false);
			} else {
				setIsLoading(false);
				setIs404(true);
				setIsError(null);
			}
		} else {
			setIsLoading(false);
			setIs404(false);
			setIsError("Choose a seller account in the top navigation to begin.");
		}
    }

	const LoadTable = () => {
		if(IsLoading) {
			return <Loading />
		} else if (Is404) {
			return <Record404 />
		} else if (IsError) {
			return <PrintErrorMsg msg={IsError} />
		} else {
			return <Table loadapidata={loadApiData} offset={offset} list={ListData} orgInfo={orgInfo} token={token} paginationNo={paginationNo} urlaccountid={selectedAccountId} urlaccountdomain={selectedAccountDomain} selectedids={SelectedIds} ontoggleselect={toggleSelect} />
		}
	}

	useEffect(() => {
		loadApiData((offset == 1) ? 0 : offset);
	}, [selectedAccountId, urlSearchQ, paginationNo]);

	useEffect(() => {
		setSelectedIds([]);
	}, [ListData]);

	return (
		<>
			<ToastContainer />
			<Navigation orgInfo={orgInfo} />
			<Container>
				<Row>
					<Col>
                        <div className="mt-3">
                            <h3 className="fs-20rem text-left vt-txt-dark-blue">Inventory List</h3>
                            <BreadcrumbNav list={[{label: 'Home', url: '/'}, {label: `Inventory - (${TotalListCount})`, url: false}]} />
                        </div>
                    </Col>
                    <Col>
                        <div className="text-right d-flex justify-content-end h-100 align-items-center gap-2">
                            <Button variant="outline-primary" type="button" size="md" disabled={!hasSelectedAccount} onClick={() => setShowUploadModalBox(true)} className="fs-14rem">UPLOAD EXCEL</Button>
                            <Button variant="primary" type="button" size="md" disabled={!hasSelectedAccount} onClick={() => setShowFormModalBox(true)} className="vt-primary-btn border-0 text-white fs-14rem">ADD INVENTORY</Button>
                        </div>
                    </Col>
                    <hr />
				</Row>
				<Row>
					<Col md="7" lg="8" className="d-flex align-items-end justify-content-start mb-3">
						<div className="form-check me-3">
							<input
								className="form-check-input"
								type="checkbox"
								id="selectAllInventory"
								checked={ListData.length > 0 && SelectedIds.length === ListData.length}
								onChange={toggleSelectAll}
								disabled={!ListData.length}
							/>
							<label className="form-check-label fs-13rem" htmlFor="selectAllInventory">Select all (this page)</label>
						</div>
						<Button variant="outline-primary" size="sm" className="fs-13rem" disabled={!SelectedIds.length || IsDownloadingSelected} onClick={handleDownloadSelected}>
							{IsDownloadingSelected ? 'Downloading...' : `Download Selected (${SelectedIds.length})`}
						</Button>
					</Col>
					<Col md="5" lg="4" className="mb-3 ms-md-auto">
						<div className="text-md-end"><label className="form-label fs-13rem fw-bold">Search Via Product Name</label></div>
						<div className="input-group">
							<input type="text" className="form-control" defaultValue={urlSearchQ} onKeyUp={handleChangeSearchQuery} placeholder="Product Name" aria-label="Product Name" />
							<div className="input-group-append">
								<Button variant="secondary" className="btn text-white btn-outline-secondary rounded-0" onClick={submitSearchQuery} type="button" disabled={!hasSelectedAccount}>Search</Button>
							</div>
						</div>
					</Col>
				</Row>
				<Row>
					<Col>
						<LoadTable />
					</Col>
				</Row>
				<Row>
					<Col>
						<div className="d-flex justify-content-center my-2">
							<Pagination
								activePage={activePage}
								itemsCountPerPage={config.pagination.limitPerPage}
								totalItemsCount={parseInt(TotalListCount)}
								pageRangeDisplayed={5}
								onChange={(e) => handlePageChange(e)}
								innerClass="pagination"
								itemClass="page-item"
								linkClass="page-link"
								activeClass="active"
							/>
						</div>
					</Col>
				</Row>
			</Container>
			{(ShowFormModalBox) ? <FormModal loadapidata={loadApiData} apidataparams={(offset == 1) ? 0 : offset} urlaccountid={selectedAccountId} urlaccountdomain={selectedAccountDomain} setshowformmodalbox={setShowFormModalBox} productid={0} token={token} orginfo={orgInfo} /> : null}
			{(ShowUploadModalBox) ? <UploadModal setShowUploadModal={setShowUploadModalBox} loadapidata={loadApiData} apidataparams={(offset == 1) ? 0 : offset} urlaccountid={selectedAccountId} token={token} /> : null}
		</>
	)
}

export default List;
